import React from "react";
import "./styles.scss";
import { Modal } from "@material-ui/core";
import { IconClose, InfoIcon } from "../../Assets/images/svg";

const InvalidLicenseModal = ({
  open,
  handleCloseLicense,
  title = "Your License is invalid",
  description = "Please Upgrade to get access",
}) => {
  return (
    <>
      <Modal
        open={open}
        onClose={handleCloseLicense}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          border: "none",
        }}
      >
        <div className="license-modal">
          <div className="license-modal-header">
            <InfoIcon />
            <span className="license-modal-title">{title}</span>
          </div>
          <span className="license-modal-des">{description}</span>
          <div className="icon-close" onClick={handleCloseLicense}>
            <IconClose />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default InvalidLicenseModal;
